import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="23" cy="23" r="23" fill="url(#paint03_radial)"/>
        <defs>
            <radialGradient id="paint03_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(23 23) rotate(90) scale(23)">
                <stop stopColor="#1A98FF"/>
                <stop offset="1" stopColor="#1A98FF" stopOpacity="0"/>
            </radialGradient>
        </defs>
    </svg>
)
